import { createFileRoute } from '@tanstack/react-router'
import { MeetingGuestPage } from '@/components/meeting/guest-page'
export const Route = createFileRoute('/meeting/guest/$token')({ component: MeetingGuestPage })
